import { useState, useEffect, useRef } from 'react'
import * as ls from '../../utils/localStorage'

const useLocalStorage = (key, initial, removeguid) => {
  const isFirstRun = useRef(true)
  const [localItems, setLocalItems] = useState(initial)

  useEffect(() => {
    if (isFirstRun.current) {
      const stored = ls.get(key)
      setLocalItems(stored !== null ? stored : initial)
      isFirstRun.current = false
      return
    }

    ls.save(key, localItems, removeguid)
  }, [localItems, removeguid])

  return [localItems, setLocalItems]
}

export default useLocalStorage
